export default __webpack_public_path__ + "media/zurb/img/case-study-pen-cal/pencal-img2-97e3385d851c10a68d75d582240ad347.jpg";